import { createCommand } from '@atlassian/rovo-content-bridge-api';
/**
 * A command sent by a bridge API client to return the current space data shown in the staging area during the smart create space flow.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to return the current space data.
 */
export var ReadSpaceCommand = createCommand('read-space-command');